// Global styles for every page. The old theme and parallax wrappers went with the 2026 redesign.
import "./src/styles/site.css"
